<template lang="pug">
  .service-content-container
    .service-content__desc
      .content__desc__title {{ $t('企业垫资解决方案') }}
      .content__desc {{ $t('复歌通过大数据匹配，基于合作的广告主或代理商财务流水，为其提供单笔或多笔垫资，有效降低企业风险。') }}

    .service-container__subTitle
      img(src="@/assets/icon-challenge.png")
      .subTitle {{ $t('企业面临的挑战与痛点') }}

    .service-challenge-container.service-challenge-container__min
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconjiage(
          style="width: 23px"
        )
        .item__title {{ $t('风险巨大') }}
        .item__desc {{ $t('广告企业公司大都存在甲方支付周期长,而执行方账期短的垫资需求。然而广告行业风险巨大，有时存在甲方倒闭或者延期支付风险，导致广告企业存在坏账风险。') }}
      .challenge__item
        img(
          src="@/assets/service-challenge-img.png"
        )
        i.iconfont.iconpinggu(
          style="width: 17px"
        )
        .item__title {{ $t('无人垫付') }}
        .item__desc {{ $t('广告公司多属于轻资产，垫款风险高，导致垫资方不愿对该行业贷款。') }}
    .service-container__subTitle
      img(src="@/assets/icon-project.png")
      .subTitle {{ $t('复歌的解决方案') }}

    .service-solution-container
      .solution-item
        .solution-content
          .solution-content__title {{ $t('大数据') }}
          .solution-content__desc {{ $t('通过让广告公司使用内部流程系统，系统化获得完整正确数据，并对历史数据进行分析。获得可靠流水数据，从而降低垫资风险。')}}
        img(
          src="@/assets/service-launch-1.png"
        )
</template>

<script>
export default {
  components: {

  }
}
</script>
